import React from 'react';
import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';
import {requestRecentMovies} from '../../../SHARED/actions/movies.actions';
import connect from "react-redux/es/connect/connect";
import ModalContentCarousel from "../../../SHARED/components/modalcontentcarousel/modalcontentcarousel.component";

class ModalCarousel extends React.Component {

    componentWillMount() {
        this.props.requestRecentMovies();
    };

    getCards = () => {
        if(this.props.images){
            return this.props.images;
        }
    };

    render() {
        return (
            <div>
                <Modal size={'lg'} isOpen={this.props.openModal} toggle={this.props.toggle} className={this.props.className}>
                    <ModalBody>
                        <ModalContentCarousel cards={this.getCards()} defaultSlidesToShow={1}/>
                    </ModalBody>
                </Modal>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    recentMovies: state.movies.recentMovies
});
export default connect(mapStateToProps, {requestRecentMovies})(ModalCarousel);


// WEBPACK FOOTER //
// ./src/FO/components/modalcarousel/modalcarousel.component.js